(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-daynight"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var root = document.querySelector('[data-rhythm-scene]');
    if (!root) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Reduced motion or no IntersectionObserver: keep the readable stacked base. No pin, no rAF.
    if (reduce || !('IntersectionObserver' in window)) return;

    var skyDay = root.querySelector('.daynight-sky.day');
    var skyDusk = root.querySelector('.daynight-sky.dusk');
    var stars = root.querySelector('.daynight-stars');
    var sun = root.querySelector('.daynight-sun');
    var moon = root.querySelector('.daynight-moon');
    var hillsDay = root.querySelector('.daynight-hills.day');
    var hillsNight = root.querySelector('.daynight-hills.night');
    var canR = root.querySelector('.daynight-can.rise');
    var canD = root.querySelector('.daynight-can.drift');
    var copyR = root.querySelector('.daynight-copy.rise');
    var copyD = root.querySelector('.daynight-copy.drift');
    var prog = root.querySelector('.daynight-prog span');

    root.classList.add('daynight-on'); // switch to the pinned scrub layout

    function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }
    function smooth(a, b, x) { var t = clamp((x - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); }
    function tri(p, c, w) { return clamp(1 - Math.abs(p - c) / w, 0, 1); }

    var rafId = 0, visible = false;

    function frame() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var r = root.getBoundingClientRect();
      var span = root.offsetHeight - vh;
      var p = span > 0 ? clamp(-r.top / span, 0, 1) : 0;
      var sw = smooth(0.42, 0.60, p); // RISE -> DRIFT can crossfade

      if (skyDay) skyDay.style.opacity = tri(p, 0.28, 0.40).toFixed(3);
      if (skyDusk) skyDusk.style.opacity = tri(p, 0.72, 0.34).toFixed(3);
      if (stars) stars.style.opacity = (smooth(0.58, 0.92, p) * 0.95).toFixed(3);

      if (sun) {
        var ps = clamp(p / 0.58, 0, 1);
        var sx = (6 + ps * 88).toFixed(2);
        var sy = (88 - Math.sin(ps * Math.PI) * 74).toFixed(2);
        sun.style.transform = 'translate(calc(' + sx + 'vw - 50%), calc(' + sy + 'vh - 50%))';
        sun.style.opacity = (1 - smooth(0.5, 0.64, p)).toFixed(3);
      }
      if (moon) {
        var pm = clamp((p - 0.42) / 0.58, 0, 1);
        var mx = (10 + pm * 80).toFixed(2);
        var my = (84 - Math.sin(pm * Math.PI) * 66).toFixed(2);
        moon.style.transform = 'translate(calc(' + mx + 'vw - 50%), calc(' + my + 'vh - 50%))';
        moon.style.opacity = smooth(0.46, 0.62, p).toFixed(3);
      }

      var hp = smooth(0.5, 0.82, p);
      if (hillsDay) hillsDay.style.opacity = (1 - hp).toFixed(3);
      if (hillsNight) hillsNight.style.opacity = hp.toFixed(3);

      if (canR) { canR.style.opacity = (1 - sw).toFixed(3); canR.style.pointerEvents = sw < 0.5 ? 'auto' : 'none'; }
      if (canD) { canD.style.opacity = sw.toFixed(3); canD.style.pointerEvents = sw >= 0.5 ? 'auto' : 'none'; }
      if (copyR) copyR.style.opacity = (1 - sw).toFixed(3);
      if (copyD) copyD.style.opacity = sw.toFixed(3);
      if (prog) prog.style.transform = 'scaleX(' + p.toFixed(3) + ')';

      rafId = visible ? requestAnimationFrame(frame) : 0;
    }
    function pump() { if (!rafId && visible) rafId = requestAnimationFrame(frame); }

    var io = new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      if (visible) pump();
    }, { threshold: 0 });
    io.observe(root);

    // initial paint: set the scene to current scroll position (and start the loop if in view)
    var r0 = root.getBoundingClientRect();
    visible = r0.top < (window.innerHeight || 0) && r0.bottom > 0;
    frame();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
